import { Container, Grid } from '@material-ui/core';
import { useEffect, useState, useCallback, useMemo } from 'react';
import stylePageMargens, {
  PageGrid, PageInner,
  SearchModeBar, SearchModeTab, ClearBtn,
  SearchBox, SearchField, SearchLabel, SearchInput, SearchBtn,
  LoadingRow, Spinner, ErrorBox,
  SummaryRow, SummaryCard, CardLabel, CardValue,
  SectionHeader, SectionTitle, Badge, StatusBadge,
  ItemsList, ItemRow, ItemName, ItemMeta, MetaKey, MetaVal,
  ItemMarginWrap, ItemMarginLabel, ItemMarginValue,
  ItemPrices, PriceCell, PriceCellLabel, PriceCellValue,
  TotalRow, TotalRowLabel, TotalFigures, TotalPct,
  SuggestArea, SuggestHeader, SuggestTitleWrap, SuggestIconBox,
  SuggestTitle, SuggestSubtitle,
  SuggestOk, SuggestOkTitle, SuggestOkSub,
  GapRow, GapStatLabel, GapStatValue,
  GapBarWrap, GapBarLabels, GapBarTrack, GapBarFill, GapBarMarker,
  SuggestImpossible, ImpossibleTitle, ImpossibleBody,
  SuggestCards, SuggestCard, SuggestCardInner,
  ScRank, ScName, ScMeta, ScMetaKey, ScMetaVal,
  ScQtyWrap, ScQtyLabel, ScQtyValue, ScQtyUnit,
  ScImpact, ImpactLabel, ImpactBefore, ImpactArrow, ImpactAfter, ImpactExtra,
  SuggestCombo, ComboTitle, ComboItems, ComboItem,
  ComboItemName, ComboItemQty, ComboItemImpact,
  ComboResult, ComboResultValue, ComboResultExtra,
  HistoricoPill,
  HistoricoArea, HistoricoStats, HistoricoStatCard,
  HistoricoOrderCard, HistoricoOrderHeader, HistoricoOrderInfo,
  HistoricoOrderTitle, HistoricoOrderMeta, HistoricoOrderRight,
  HistoricoOrderTotal, HistoricoOrderPct, HistoricoToggleBtn,
  HistoricoItemsWrap, HistoricoItemRow, HistoricoItemImg,
  HistoricoItemInfo, HistoricoItemName, HistoricoItemMeta,
  HistoricoItemRight, HistoricoItemPrice, HistoricoItemPct,
  HistoricoEmpty,
  NewOrderBanner, ClienteBanner,
  BannerIcon, BannerInfo, BannerTitle, BannerSub, BannerStrong, DocBadge,
  EffMetaCard, EffMetaCell, EffMetaLabel, EffMetaValue, EffMetaBadge,
  CompletaArea, CompletaGrid, CompletaCard,
  CompletaCardHeader, CompletaCardMeta, CompletaCardNumLabel,
  CompletaCardTitle, CompletaCardDesc,
  CompletaMargemDisplay, CompletaMargemLabel, CompletaMargemPct, CompletaMargemStatus,
  CompletaGroupLabel, CompletaDivider,
  CompletaItemLine, CompletaItemTag, CompletaItemLineLeft,
  CompletaItemLineName, CompletaItemLineMeta,
  CompletaItemLineRight, CompletaItemLineQtyBadge,
  CompletaItemLinePrice, CompletaItemLinePct,
  CompletaFooter, CompletaFooterCell, CompletaFooterCellLabel, CompletaFooterCellValue,
  CompletaNoData,
  PageFooter,
} from './style';
import { apiLabs, apiTelevendasBlue, apiTelevendasIDW } from '../../Services/api';
import { store } from '../../store';
import history from '../../Services/history';
import Dashboard from '../../Components/Dashboard';
import Denied from '../../Components/Denied';

// ─── Constants ────────────────────────────────────────────────────────────────
const META = 25.50;

// ─── Formatters ───────────────────────────────────────────────────────────────
const fmt = v => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(v);
const fmtPct = v => `${Number(v).toFixed(2)}%`;
const fmtDate = iso => { try { return new Date(iso).toLocaleDateString('pt-BR'); } catch { return '—'; } };
const stripLetters = s => s.replace(/[^0-9]/g, '');
const delay = ms => new Promise(r => setTimeout(r, ms));

/**
 * Aplica máscara de CPF (000.000.000-00) ou CNPJ (00.000.000/0001-00)
 * conforme a quantidade de dígitos digitada.
 */
function applyDocMask(v) {
  const d = v.replace(/\D/g, '').slice(0, 14);
  if (d.length <= 11) {
    return d
      .replace(/^(\d{3})(\d)/, '$1.$2')
      .replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3')
      .replace(/^(\d{3})\.(\d{3})\.(\d{3})(\d)/, '$1.$2.$3-$4');
  }
  return d
    .replace(/^(\d{2})(\d)/, '$1.$2')
    .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
    .replace(/^(\d{2})\.(\d{3})\.(\d{3})(\d)/, '$1.$2.$3/$4')
    .replace(/^(\d{2})\.(\d{3})\.(\d{3})\/(\d{4})(\d)/, '$1.$2.$3/$4-$5');
}

function valueVariant(m, target = META) {
  if (m >= target) return 'positive';
  if (m >= META && m >= 15) return 'warning';
  if (m >= 15) return 'warning';
  return 'negative';
}
function marginClass(m) {
  if (m >= META) return 'pos';
  if (m >= 15) return 'warn';
  return 'neg';
}

// ─── Suggestion Engine — ajuste de quantidades ────────────────────────────────
function calcQtyNeeded(TV, TC, p, c) {
  const m = META / 100;
  const num = m * TV - (TV - TC), denom = (1 - m) * p - c;
  if (denom <= 0) return null;
  const qty = Math.ceil(num / denom);
  return qty > 0 ? qty : null;
}
function calcMargemWith(TV, TC, extras) {
  let nTV = TV, nTC = TC;
  extras.forEach(({ p, c, qty }) => { nTV += p * qty; nTC += c * qty; });
  return nTV > 0 ? ((nTV - nTC) / nTV) * 100 : 0;
}
function calcComboQty(TV, TC, candidates, max = 3) {
  const pool = candidates.slice(0, max);
  for (let step = 1; step <= 1000; step++) {
    const extras = pool.map(it => ({ p: it.priceSelling, c: it.custo, qty: step }));
    if (calcMargemWith(TV, TC, extras) >= META) return { pool, step };
  }
  return null;
}
function computeSugestao(items, TV, TC, margemAtual, histItems = []) {
  if (margemAtual >= META) return { type: 'ok', margemAtual };
  const gap = META - margemAtual;
  const pct = Math.min((margemAtual / META) * 100, 100).toFixed(1);
  const currentIds = new Set(items.map(i => i.idSkuCompany).filter(Boolean));
  const allCands = [
    ...items.filter(it => it.margem > META && it.priceSelling > 0 && it.custo > 0),
    ...histItems.filter(it => it.margem > META && it.priceSelling > 0 && it.custo > 0 && !currentIds.has(it.idSkuCompany)).map(it => ({ ...it, fromHistory: true })),
  ].sort((a, b) => b.margem - a.margem);
  if (!allCands.length) return { type: 'impossible', gap, pct, margemAtual, singles: [], combo: null };
  const singles = allCands.map(it => { const qty = calcQtyNeeded(TV, TC, it.priceSelling, it.custo); if (!qty) return null; return { item: it, qty, newM: calcMargemWith(TV, TC, [{ p: it.priceSelling, c: it.custo, qty }]) }; }).filter(Boolean).sort((a, b) => a.qty - b.qty);
  let combo = null;
  if (allCands.length >= 2) {
    const raw = calcComboQty(TV, TC, allCands, Math.min(allCands.length, 3));
    if (raw) {
      const { pool, step } = raw;
      if (pool.length * step < (singles[0]?.qty ?? Infinity)) {
        const extras = pool.map(it => ({ p: it.priceSelling, c: it.custo, qty: step }));
        combo = { pool, step, comboM: calcMargemWith(TV, TC, extras), addVend: extras.reduce((s, e) => s + e.p * e.qty, 0), addCust: extras.reduce((s, e) => s + e.c * e.qty, 0), totalQtyCombo: pool.length * step };
      }
    }
  }
  return { type: 'below', gap, pct, margemAtual, singles: singles.slice(0, 5), combo };
}

// ─── Complete Order Suggestions — pedido com itens ────────────────────────────
function computeCompleteSuggestions(currentItems, TV, TC, margemAtual, histItems) {
  if (!histItems?.length) return [];
  const alreadyOk = margemAtual >= META;
  const currentIds = new Set(currentItems.map(i => i.idSkuCompany).filter(Boolean));
  const histPool = histItems.filter(it => it.margem > META && it.custo > 0 && it.priceSelling > 0 && !currentIds.has(it.idSkuCompany)).sort((a, b) => b.margem - a.margem);
  const orderPool = currentItems.filter(it => it.margem > META && it.priceSelling > 0 && it.custo > 0).sort((a, b) => b.margem - a.margem).map(it => ({ ...it, fromCurrentOrder: true }));
  const combined = [...histPool, ...orderPool];
  if (!combined.length) return [];
  const sugs = [];
  // S1
  (() => {
    let additions = [], nTV = TV, nTC = TC;
    if (alreadyOk) { const b = histPool[0] || orderPool[0]; if (!b) return; const addedQty = Math.max(b.quantity || 1, 1); additions = [{ ...b, addedQty }]; nTV += b.priceSelling * addedQty; nTC += b.custo * addedQty; }
    else { for (const c of combined) { const qty = calcQtyNeeded(nTV, nTC, c.priceSelling, c.custo); if (!qty) continue; additions = [{ ...c, addedQty: qty }]; nTV += c.priceSelling * qty; nTC += c.custo * qty; break; } }
    if (!additions.length) return;
    const margem = nTV > 0 ? ((nTV - nTC) / nTV) * 100 : 0;
    sugs.push({ num: 1, icon: '⚡', label: 'Sugestão 1 — Adição Direta', title: 'Adição Direta', description: alreadyOk ? 'Upsell: produto de alta margem já comprado' : 'Menor esforço para bater a meta', currentItems, additions, TV: nTV, TC: nTC, margem, achieved: margem >= META });
  })();
  // S2
  (() => {
    const pool = combined.slice(0, Math.min(3, combined.length));
    if (!pool.length) return;
    let additions = [], nTV = TV, nTC = TC;
    if (alreadyOk) { additions = pool.map(c => ({ ...c, addedQty: Math.max(c.quantity || 1, 1) })); nTV += additions.reduce((s, a) => s + a.priceSelling * a.addedQty, 0); nTC += additions.reduce((s, a) => s + a.custo * a.addedQty, 0); }
    else {
      let found = false;
      for (let step = 1; step <= 500; step++) { const extras = pool.map(it => ({ p: it.priceSelling, c: it.custo, qty: step })); const tTV = TV + extras.reduce((s, e) => s + e.p * e.qty, 0), tTC = TC + extras.reduce((s, e) => s + e.c * e.qty, 0); if (tTV > 0 && ((tTV - tTC) / tTV) * 100 >= META) { additions = pool.map(c => ({ ...c, addedQty: step })); nTV = tTV; nTC = tTC; found = true; break; } }
      if (!found) { additions = pool.map(c => ({ ...c, addedQty: 1 })); nTV = TV + additions.reduce((s, a) => s + a.priceSelling * a.addedQty, 0); nTC = TC + additions.reduce((s, a) => s + a.custo * a.addedQty, 0); }
    }
    const margem = nTV > 0 ? ((nTV - nTC) / nTV) * 100 : 0;
    sugs.push({ num: 2, icon: '⚖️', label: 'Sugestão 2 — Mix Balanceado', title: 'Mix Balanceado', description: alreadyOk ? `Upsell: ${pool.length} produtos do histórico` : `Distribuição entre ${pool.length} produtos do histórico`, currentItems, additions, TV: nTV, TC: nTC, margem, achieved: margem >= META });
  })();
  return sugs;
}

// ─── Complete Order Suggestions — NOVO PEDIDO / cliente ──────────────────────
function computeNewOrderSuggestions(histItems, effectiveMeta) {
  if (!histItems?.length) return [];
  const qualified = histItems.filter(it => it.margem >= effectiveMeta && it.custo > 0 && it.priceSelling > 0);
  const pool = qualified.length ? qualified : histItems.filter(it => it.margem >= META && it.custo > 0 && it.priceSelling > 0);
  if (!pool.length) return [];
  const calcFin = items => { const TV = items.reduce((s, i) => s + i.priceSelling * i.addedQty, 0), TC = items.reduce((s, i) => s + i.custo * i.addedQty, 0); return { TV, TC, margem: TV > 0 ? ((TV - TC) / TV) * 100 : 0 }; };
  const byMargem = [...pool].sort((a, b) => b.margem - a.margem).slice(0, 5);
  const s1Items = byMargem.map(it => ({ ...it, addedQty: Math.max(it.quantity || 1, 1) }));
  const { TV: s1TV, TC: s1TC, margem: s1M } = calcFin(s1Items);
  const byQty = [...pool].sort((a, b) => (b.quantity || 0) - (a.quantity || 0)).slice(0, 7);
  const s1Ids = new Set(byMargem.map(i => i.idSkuCompany));
  const s2Same = byQty.length <= byMargem.length && byQty.every(i => s1Ids.has(i.idSkuCompany));
  const s2Items = byQty.map(it => ({ ...it, addedQty: s2Same ? Math.max((it.quantity || 1) * 2, 2) : Math.max(it.quantity || 1, 1) }));
  const { TV: s2TV, TC: s2TC, margem: s2M } = calcFin(s2Items);
  const effLbl = fmtPct(effectiveMeta);
  const adj = effectiveMeta > META;
  return [
    { num: 1, icon: '⚡', label: 'Sugestão 1 — Alta Margem', title: 'Alta Margem', description: `${s1Items.length} produto${s1Items.length > 1 ? 's' : ''} de maior margem individual do histórico${adj ? ` (>= ${effLbl})` : ''}`, isNewOrder: true, additions: s1Items, currentItems: [], TV: s1TV, TC: s1TC, margem: s1M, achieved: s1M >= effectiveMeta, effectiveMeta },
    { num: 2, icon: s2Same ? '📦' : '⚖️', label: s2Same ? 'Sugestão 2 — Reposição Ampliada' : 'Sugestão 2 — Mix Histórico', title: s2Same ? 'Reposição Ampliada' : 'Mix Histórico', description: s2Same ? 'Mesmos produtos com o dobro das quantidades habituais' : `${s2Items.length} produto${s2Items.length > 1 ? 's' : ''} mais comprados pelo cliente${adj ? ` (>= ${effLbl})` : ''}`, isNewOrder: true, additions: s2Items, currentItems: [], TV: s2TV, TC: s2TC, margem: s2M, achieved: s2M >= effectiveMeta, effectiveMeta },
  ];
}

// ─── API Layer ────────────────────────────────────────────────────────────────
async function fetchCustoByGtin(barcode) {
  try { await delay(500); const r = await apiTelevendasBlue.get('/product', { params: { lojaKey: 3, gtin: barcode } }); const arr = r.data?.data || r.data?.Data || []; return arr.length ? Number(arr[0].custoMedioComImposto ?? 0) : 0; } catch { return 0; }
}
async function fetchCustoByProdutoKey(id) {
  try { await delay(500); const r = await apiTelevendasBlue.get('/product', { params: { lojaKey: 3, produtoKey: id } }); const arr = r.data?.data || r.data?.Data || []; return arr.length ? Number(arr[0].custoMedioComImposto ?? 0) : 0; } catch { return 0; }
}

async function fetchOrder(orderNum, onProgress) {
  onProgress('CONSULTANDO PEDIDO NO IDWORKS...');
  const r1 = await apiTelevendasIDW.get(`/orders/${orderNum}`);
  const j1 = r1.data;
  if (!j1 || !j1.length) throw new Error('Pedido não encontrado na API IDWorks.');
  const pedido = j1[0];
  const consumerCpfCnpj = pedido.ConsumerCpfCnpj || pedido.consumerCpfCnpj || '';
  const consumerName = pedido.ConsumerNameCorporateName || pedido.consumerName || '';
  const rawItems = pedido.Items || pedido.items || [];
  if (!rawItems.length) return { items: [], TV: 0, TC: 0, margemPedido: 0, consumerCpfCnpj, consumerName, isNewOrder: true };
  onProgress(`CONSULTANDO CUSTOS (0 / ${rawItems.length})...`);
  const enriched = [];
  for (let i = 0; i < rawItems.length; i++) {
    const item = rawItems[i];
    onProgress(`CONSULTANDO CUSTOS (${i + 1} / ${rawItems.length})...`);
    const barcode = item.BarCode || item.barCode || item.barcode || '';
    const idSkuCompany = item.IDSkuCompany || item.idSkuCompany || '';
    const quantity = Number(item.Quantity ?? item.quantity ?? 0);
    const priceSelling = Number(item.PriceSelling ?? item.priceSelling ?? 0);
    const name = item.SkuName || item.Description || item.Name || `Produto #${i + 1}`;
    const imageUrl = item.MainImageURL || '';
    const custo = await fetchCustoByGtin(barcode);
    const margem = priceSelling > 0 ? ((priceSelling - custo) / priceSelling) * 100 : 0;
    enriched.push({ name, barcode, idSkuCompany, imageUrl, quantity, priceSelling, custo, margem });
  }
  const TV = enriched.reduce((s, x) => s + x.priceSelling * x.quantity, 0);
  const TC = enriched.reduce((s, x) => s + x.custo * x.quantity, 0);
  return { items: enriched, TV, TC, margemPedido: TV > 0 ? ((TV - TC) / TV) * 100 : 0, consumerCpfCnpj, consumerName, isNewOrder: false };
}

async function fetchHistorico(cpfCnpj, onProgress) {
  onProgress('BUSCANDO HISTÓRICO DO CLIENTE...');
  const r = await apiTelevendasIDW.get('/orders', { params: { SkuView: 1, OrderByRule: 'OrderDesc', IDStatusOrder: '8,7', IDOrderType: 877, ConsumerCpfCnpj: cpfCnpj, InvoiceDateFrom: `${new Date().getFullYear() - 1}-01-01`, InvoiceDateTo: `${new Date().getFullYear()}-12-31` } });
  const pedidos = (r.data || []).slice(0, 15);
  if (!pedidos.length) return { orders: [], histItems: [], consumerName: '' };
  const totalItems = pedidos.reduce((s, p) => s + (p.Items || []).length, 0);
  let done = 0;
  const histMap = {};
  const enrichedOrders = [];
  for (const pedido of pedidos) {
    const rawItems = pedido.Items || pedido.items || [];
    const orderItems = [];
    for (const item of rawItems) {
      done++;
      onProgress(`HISTÓRICO: CUSTOS (${done} / ${totalItems})...`);
      const idSkuCompany = item.IDSkuCompany || item.idSkuCompany || '';
      const priceSelling = Number(item.PriceSelling ?? item.priceSelling ?? 0);
      const quantity = Number(item.Quantity ?? item.quantity ?? 0);
      const name = item.SkuName || item.SkuNameOnly || `SKU ${idSkuCompany}`;
      const imageUrl = item.MainImageURL || '';
      let custo = 0;
      if (idSkuCompany) custo = await fetchCustoByProdutoKey(idSkuCompany);
      const margem = priceSelling > 0 ? ((priceSelling - custo) / priceSelling) * 100 : 0;
      const ei = { name, idSkuCompany, imageUrl, quantity, priceSelling, custo, margem };
      orderItems.push(ei);
      if (idSkuCompany && !histMap[idSkuCompany]) histMap[idSkuCompany] = ei;
    }
    const oTV = orderItems.reduce((s, x) => s + x.priceSelling * x.quantity, 0);
    const oTC = orderItems.reduce((s, x) => s + x.custo * x.quantity, 0);
    enrichedOrders.push({
      idOrder: pedido.IDOrder, order: pedido.Order, date: pedido.Recordtimestamp,
      status: pedido.StatusOrder, total: Number(pedido.ValueOrder || 0),
      consumerName: pedido.ConsumerNameCorporateName || '',
      items: orderItems, TV: oTV, TC: oTC,
      margem: oTV > 0 ? ((oTV - oTC) / oTV) * 100 : 0,
    });
  }
  return { orders: enrichedOrders, histItems: Object.values(histMap), consumerName: enrichedOrders[0]?.consumerName || '' };
}

// ──────────────────────────────────────────────────────────────────────────────
//  SUB-COMPONENTS
// ──────────────────────────────────────────────────────────────────────────────

function OrderItem({ item, index }) {
  return (
    <ItemRow $mc={marginClass(item.margem)} $delay={`${index * 0.06}s`}>
      <div>
        <ItemName>{item.name}</ItemName>
        <ItemMeta>
          <span><MetaKey>EAN/PLU</MetaKey><MetaVal>{item.barcode || '—'}</MetaVal></span>
          <span><MetaKey>QTD</MetaKey><MetaVal>{item.quantity}</MetaVal></span>
        </ItemMeta>
      </div>
      <ItemMarginWrap>
        <ItemMarginLabel>Margem</ItemMarginLabel>
        <ItemMarginValue $variant={valueVariant(item.margem)}>{fmtPct(item.margem)}</ItemMarginValue>
      </ItemMarginWrap>
      <ItemPrices>
        <PriceCell><PriceCellLabel>Preço de Venda</PriceCellLabel><PriceCellValue>{fmt(item.priceSelling)}</PriceCellValue></PriceCell>
        <PriceCell><PriceCellLabel>Custo Atual</PriceCellLabel><PriceCellValue $color={item.custo > 0 ? undefined : '#5a6070'}>{item.custo > 0 ? fmt(item.custo) : 'Não encontrado'}</PriceCellValue></PriceCell>
        <PriceCell><PriceCellLabel>Subtotal Venda</PriceCellLabel><PriceCellValue>{fmt(item.priceSelling * item.quantity)}</PriceCellValue></PriceCell>
        <PriceCell><PriceCellLabel>Subtotal Custo</PriceCellLabel><PriceCellValue $color={item.custo > 0 ? undefined : '#5a6070'}>{item.custo > 0 ? fmt(item.custo * item.quantity) : '—'}</PriceCellValue></PriceCell>
      </ItemPrices>
    </ItemRow>
  );
}

function HistoricoOrderItem({ order, index }) {
  const [open, setOpen] = useState(false);
  const mc = marginClass(order.margem);
  return (
    <HistoricoOrderCard $mc={mc} $delay={`${index * 0.07}s`}>
      <HistoricoOrderHeader onClick={() => setOpen(o => !o)}>
        <HistoricoOrderInfo>
          <HistoricoOrderTitle>{order.order || `#${order.idOrder}`}</HistoricoOrderTitle>
          <HistoricoOrderMeta><span>📅 {fmtDate(order.date)}</span><span>📦 {order.items.length} {order.items.length === 1 ? 'item' : 'itens'}</span><span>{order.status}</span></HistoricoOrderMeta>
        </HistoricoOrderInfo>
        <HistoricoOrderRight>
          <HistoricoOrderTotal>{fmt(order.total)}</HistoricoOrderTotal>
          <HistoricoOrderPct $variant={valueVariant(order.margem)}>{fmtPct(order.margem)}</HistoricoOrderPct>
        </HistoricoOrderRight>
        <HistoricoToggleBtn $open={open}>▾</HistoricoToggleBtn>
      </HistoricoOrderHeader>
      {open && (
        <HistoricoItemsWrap>
          {order.items.map((item, i) => (
            <HistoricoItemRow key={item.idSkuCompany || i} $mc={marginClass(item.margem)}>
              <HistoricoItemImg src={item.imageUrl || 'https://via.placeholder.com/36x36/1e2129/5a6070?text=?'} alt="" onError={e => { e.target.src = 'https://via.placeholder.com/36x36/1e2129/5a6070?text=?'; }} />
              <HistoricoItemInfo>
                <HistoricoItemName title={item.name}>{item.name}</HistoricoItemName>
                <HistoricoItemMeta><span>SKU {item.idSkuCompany || '—'}</span><span>Qtd {item.quantity}</span>{item.custo > 0 && <span>Custo {fmt(item.custo)}</span>}</HistoricoItemMeta>
              </HistoricoItemInfo>
              <HistoricoItemRight>
                <HistoricoItemPrice>{fmt(item.priceSelling)}</HistoricoItemPrice>
                <HistoricoItemPct $variant={valueVariant(item.margem)}>{fmtPct(item.margem)}</HistoricoItemPct>
              </HistoricoItemRight>
            </HistoricoItemRow>
          ))}
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 16, marginTop: 8, fontSize: 10, fontFamily: "'IBM Plex Mono',monospace", color: '#5a6070' }}>
            <span>Venda: <span style={{ color: '#e8eaf0' }}>{fmt(order.TV)}</span></span>
            <span>Custo: <span style={{ color: '#e8eaf0' }}>{fmt(order.TC)}</span></span>
            <span>Margem: <span style={{ color: order.margem >= META ? '#3ecf8e' : order.margem >= 15 ? '#f87c3b' : '#f56565', fontWeight: 800 }}>{fmtPct(order.margem)}</span></span>
          </div>
        </HistoricoItemsWrap>
      )}
    </HistoricoOrderCard>
  );
}

function HistoricoSection({ historico, loading, loadingMsg }) {
  if (!loading && !historico) return null;
  const orders = historico?.orders || [], histItems = historico?.histItems || [];
  const avgM = orders.length ? orders.reduce((s, o) => s + o.margem, 0) / orders.length : 0;
  const totalG = orders.reduce((s, o) => s + o.total, 0);
  return (
    <HistoricoArea>
      <SectionHeader><SectionTitle>📋 Histórico de Compras</SectionTitle></SectionHeader>
      {loading && <LoadingRow><Spinner /><span>{loadingMsg}</span></LoadingRow>}
      {historico && (
        <>
          <HistoricoStats>
            <HistoricoStatCard><CardLabel>Pedidos</CardLabel><CardValue $variant="blue">{orders.length}</CardValue></HistoricoStatCard>
            <HistoricoStatCard><CardLabel>Produtos Únicos</CardLabel><CardValue $variant="neutral">{histItems.length}</CardValue></HistoricoStatCard>
            <HistoricoStatCard><CardLabel>Total Gasto</CardLabel><CardValue $variant="neutral">{fmt(totalG)}</CardValue></HistoricoStatCard>
            <HistoricoStatCard><CardLabel>Margem Média</CardLabel><CardValue $variant={valueVariant(avgM)}>{fmtPct(avgM)}</CardValue></HistoricoStatCard>
          </HistoricoStats>
          {orders.length === 0 ? <HistoricoEmpty>Nenhum pedido encontrado para este cliente nos últimos registros.</HistoricoEmpty> : orders.map((order, idx) => <HistoricoOrderItem key={order.idOrder || idx} order={order} index={idx} />)}
        </>
      )}
    </HistoricoArea>
  );
}

// ─── Suggestion (ajuste) ──────────────────────────────────────────────────────
function SuggestBelowPanel({ result }) {
  const { gap, pct, margemAtual, singles = [], combo } = result;
  return (
    <>
      <GapRow>
        <div style={{ flex: 1, minWidth: 90 }}><GapStatLabel>Margem Atual</GapStatLabel><GapStatValue $type="cur">{fmtPct(margemAtual)}</GapStatValue></div>
        <div style={{ flex: 1, minWidth: 90 }}><GapStatLabel>Meta Mínima</GapStatLabel><GapStatValue $type="meta">{fmtPct(META)}</GapStatValue></div>
        <div style={{ flex: 1, minWidth: 90 }}><GapStatLabel>Gap</GapStatLabel><GapStatValue $type="gap">−{fmtPct(gap)}</GapStatValue></div>
        <GapBarWrap><GapBarLabels><span>0%</span><span>Meta {fmtPct(META)}</span></GapBarLabels><GapBarTrack><GapBarFill $pct={pct} /><GapBarMarker /></GapBarTrack></GapBarWrap>
      </GapRow>
      {singles.length === 0 && <SuggestImpossible><ImpossibleTitle>⚠ Impossível atingir a meta com os produtos disponíveis</ImpossibleTitle><ImpossibleBody>· Incluir novos produtos com margem superior a {fmtPct(META)}<br />· Renegociar o custo de compra dos itens atuais<br />· Revisar o preço de venda dos produtos</ImpossibleBody></SuggestImpossible>}
      {singles.length > 0 && <SuggestCards>{singles.map(({ item, qty, newM }, idx) => (
        <SuggestCard key={item.idSkuCompany || item.barcode || idx} $delay={`${idx * 0.08}s`}>
          <SuggestCardInner>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 3 }}><ScRank style={{ margin: 0 }}>Opção {idx + 1}</ScRank>{item.fromHistory && <HistoricoPill>📦 Já comprou</HistoricoPill>}</div>
              <ScName>{item.name}</ScName>
              <ScMeta>
                {item.barcode && <span><ScMetaKey>EAN</ScMetaKey><ScMetaVal>{item.barcode}</ScMetaVal></span>}
                {item.idSkuCompany && <span><ScMetaKey>SKU</ScMetaKey><ScMetaVal>{item.idSkuCompany}</ScMetaVal></span>}
                <span><ScMetaKey>Margem</ScMetaKey><ScMetaVal $color="#3ecf8e">{fmtPct(item.margem)}</ScMetaVal></span>
                <span><ScMetaKey>Preço</ScMetaKey><ScMetaVal>{fmt(item.priceSelling)}</ScMetaVal></span>
                <span><ScMetaKey>Custo</ScMetaKey><ScMetaVal>{fmt(item.custo)}</ScMetaVal></span>
              </ScMeta>
            </div>
            <ScQtyWrap><ScQtyLabel>Adicionar</ScQtyLabel><ScQtyValue>+{qty}</ScQtyValue><ScQtyUnit>unidades</ScQtyUnit></ScQtyWrap>
            <ScImpact><ImpactLabel>Impacto</ImpactLabel><ImpactBefore>{fmtPct(margemAtual)}</ImpactBefore><ImpactArrow> → </ImpactArrow><ImpactAfter>{fmtPct(newM)}</ImpactAfter><ImpactExtra>&nbsp;|&nbsp;Venda: {fmt(item.priceSelling * qty)}</ImpactExtra></ScImpact>
          </SuggestCardInner>
        </SuggestCard>
      ))}</SuggestCards>}
      {combo && <SuggestCombo>
        <ComboTitle>💡 Alternativa Combinada — {combo.pool.length} produtos</ComboTitle>
        <ComboItems>{combo.pool.map((it, idx) => <ComboItem key={it.idSkuCompany || idx}><ComboItemName>{it.name}{it.fromHistory && <HistoricoPill style={{ marginLeft: 8 }}>📦</HistoricoPill>}</ComboItemName><ComboItemQty>+{combo.step} un.</ComboItemQty><ComboItemImpact>{fmt(it.priceSelling * combo.step)}&nbsp;|&nbsp;{fmtPct(it.margem)}</ComboItemImpact></ComboItem>)}</ComboItems>
        <ComboResult><span>Margem:</span><ComboResultValue>{fmtPct(combo.comboM)}</ComboResultValue><ComboResultExtra>·+{combo.totalQtyCombo} un.&nbsp;|&nbsp;+{fmt(combo.addVend)}&nbsp;|&nbsp;custo +{fmt(combo.addCust)}</ComboResultExtra></ComboResult>
      </SuggestCombo>}
    </>
  );
}

function SugestaoSection({ items, TV, TC, margemAtual, histItems }) {
  const result = useMemo(() => computeSugestao(items, TV, TC, margemAtual, histItems), [items, TV, TC, margemAtual, histItems]);
  const isOk = result.type === 'ok';
  return (
    <SuggestArea>
      <SuggestHeader>
        <SuggestTitleWrap><SuggestIconBox $type={isOk ? 'ok' : 'warn'}>{isOk ? '✅' : '🧠'}</SuggestIconBox><div><SuggestTitle>Sugestão de Ajuste</SuggestTitle><SuggestSubtitle>Meta mínima: <strong>{fmtPct(META)}</strong></SuggestSubtitle></div></SuggestTitleWrap>
        <StatusBadge $type={isOk ? 'ok' : 'warn'}>{isOk ? 'META ATINGIDA' : `GAP −${fmtPct(result.gap)}`}</StatusBadge>
      </SuggestHeader>
      {isOk ? <SuggestOk><span style={{ fontSize: 26 }}>🎯</span><div><SuggestOkTitle>Pedido dentro da meta!</SuggestOkTitle><SuggestOkSub>Margem atual: <strong>{fmtPct(result.margemAtual)}</strong> — supera {fmtPct(META)}.</SuggestOkSub></div></SuggestOk> : <SuggestBelowPanel result={result} />}
    </SuggestArea>
  );
}

// ─── Complete Order Card ──────────────────────────────────────────────────────
function CompleteOrderCard({ sug, index }) {
  const mc = marginClass(sug.margem);
  const effMeta = sug.effectiveMeta || META;
  return (
    <CompletaCard $mc={mc} $achieved={sug.achieved} $delay={`${index * 0.12}s`}>
      <CompletaCardHeader $mc={mc}>
        <CompletaCardMeta>
          <CompletaCardNumLabel>{sug.label}</CompletaCardNumLabel>
          <CompletaCardTitle>{sug.icon} {sug.title}</CompletaCardTitle>
          <CompletaCardDesc>{sug.description}</CompletaCardDesc>
        </CompletaCardMeta>
        <CompletaMargemDisplay>
          <CompletaMargemLabel>Margem do Pedido</CompletaMargemLabel>
          <CompletaMargemPct $variant={valueVariant(sug.margem, effMeta)}>{fmtPct(sug.margem)}</CompletaMargemPct>
          <CompletaMargemStatus $achieved={sug.achieved}>{sug.achieved ? `✓ >= ${fmtPct(effMeta)}` : `✗ Abaixo de ${fmtPct(effMeta)}`}</CompletaMargemStatus>
        </CompletaMargemDisplay>
      </CompletaCardHeader>

      {!sug.isNewOrder && sug.currentItems.length > 0 && (
        <>
          <CompletaGroupLabel>Pedido Atual — itens mantidos</CompletaGroupLabel>
          {sug.currentItems.map((item, i) => (
            <CompletaItemLine key={item.idSkuCompany || item.barcode || i} $isNew={false}>
              <CompletaItemTag $isNew={false}>ATUAL</CompletaItemTag>
              <CompletaItemLineLeft><CompletaItemLineName title={item.name}>{item.name}</CompletaItemLineName><CompletaItemLineMeta>{item.barcode && <span>EAN {item.barcode}</span>}{item.idSkuCompany && <span>SKU {item.idSkuCompany}</span>}</CompletaItemLineMeta></CompletaItemLineLeft>
              <CompletaItemLineRight><CompletaItemLineQtyBadge $isNew={false}>{item.quantity} un</CompletaItemLineQtyBadge><CompletaItemLinePrice>{fmt(item.priceSelling * item.quantity)}</CompletaItemLinePrice><CompletaItemLinePct $variant={valueVariant(item.margem)}>{fmtPct(item.margem)}</CompletaItemLinePct></CompletaItemLineRight>
            </CompletaItemLine>
          ))}
          <CompletaDivider>+ Adições do Histórico</CompletaDivider>
        </>
      )}
      {sug.isNewOrder && <CompletaGroupLabel>📦 Produtos Sugeridos do Histórico do Cliente</CompletaGroupLabel>}

      {sug.additions.map((item, i) => (
        <CompletaItemLine key={item.idSkuCompany || i} $isNew>
          <CompletaItemTag $isHist={sug.isNewOrder} $isNew={!sug.isNewOrder}>{sug.isNewOrder ? 'HIST' : 'NOVO'}</CompletaItemTag>
          <CompletaItemLineLeft>
            <CompletaItemLineName title={item.name}>{item.name}</CompletaItemLineName>
            <CompletaItemLineMeta>{item.idSkuCompany && <span>SKU {item.idSkuCompany}</span>}{sug.isNewOrder && <span style={{ color: '#60a5fa' }}>Últ. compra: {item.quantity} un</span>}</CompletaItemLineMeta>
          </CompletaItemLineLeft>
          <CompletaItemLineRight>
            <CompletaItemLineQtyBadge $isNew>{sug.isNewOrder ? `${item.addedQty} un` : `+${item.addedQty} un`}</CompletaItemLineQtyBadge>
            <CompletaItemLinePrice>{fmt(item.priceSelling * item.addedQty)}</CompletaItemLinePrice>
            <CompletaItemLinePct $variant={valueVariant(item.margem)}>{fmtPct(item.margem)}</CompletaItemLinePct>
          </CompletaItemLineRight>
        </CompletaItemLine>
      ))}

      <CompletaFooter>
        <CompletaFooterCell><CompletaFooterCellLabel>Total Venda</CompletaFooterCellLabel><CompletaFooterCellValue $variant="neutral">{fmt(sug.TV)}</CompletaFooterCellValue></CompletaFooterCell>
        <CompletaFooterCell><CompletaFooterCellLabel>Total Custo</CompletaFooterCellLabel><CompletaFooterCellValue>{fmt(sug.TC)}</CompletaFooterCellValue></CompletaFooterCell>
        <CompletaFooterCell $highlight><CompletaFooterCellLabel>Margem Bruta</CompletaFooterCellLabel><CompletaFooterCellValue $variant={valueVariant(sug.margem, effMeta)}>{fmtPct(sug.margem)}</CompletaFooterCellValue></CompletaFooterCell>
      </CompletaFooter>
    </CompletaCard>
  );
}

function CompleteOrderSection({ isNewOrder, currentItems, TV, TC, margemAtual, histItems, externalSuggestions, loadingHist, effectiveMeta }) {
  const computed = useMemo(() => { if (isNewOrder) return []; return computeCompleteSuggestions(currentItems, TV, TC, margemAtual, histItems); }, [isNewOrder, currentItems, TV, TC, margemAtual, histItems]);
  const suggestions = isNewOrder ? (externalSuggestions || []) : computed;
  const hasHist = histItems && histItems.length > 0;
  return (
    <CompletaArea>
      <SectionHeader><SectionTitle>🛒 Sugestão de Pedido Completo</SectionTitle>{suggestions.length > 0 && <Badge>{suggestions.length} Propostas</Badge>}</SectionHeader>
      {loadingHist && <LoadingRow><Spinner /><span>Aguardando histórico do cliente para montar sugestões...</span></LoadingRow>}
      {!loadingHist && !hasHist && <CompletaNoData>Nenhum produto do histórico encontrado com margem qualificada.<br />As sugestões estarão disponíveis após o carregamento do histórico.</CompletaNoData>}
      {!loadingHist && suggestions.length > 0 && <CompletaGrid>{suggestions.map((sug, idx) => <CompleteOrderCard key={sug.num} sug={sug} index={idx} />)}</CompletaGrid>}
    </CompletaArea>
  );
}

// ─── EffMetaCard shared ───────────────────────────────────────────────────────
function EffMetaSection({ avgMargemCliente, effectiveMeta }) {
  const effUp = effectiveMeta > META;
  return (
    <EffMetaCard>
      <EffMetaCell><EffMetaLabel>Meta Base</EffMetaLabel><EffMetaValue $variant="neutral">{fmtPct(META)}</EffMetaValue></EffMetaCell>
      <EffMetaCell><EffMetaLabel>Margem Média do Cliente</EffMetaLabel><EffMetaValue $variant={valueVariant(avgMargemCliente)}>{fmtPct(avgMargemCliente)}</EffMetaValue></EffMetaCell>
      <EffMetaCell>
        <EffMetaLabel>Meta Efetiva <EffMetaBadge $up={effUp}>{effUp ? '▲ Ajustada' : 'Base'}</EffMetaBadge></EffMetaLabel>
        <EffMetaValue $variant={effUp ? 'positive' : 'neutral'}>{fmtPct(effectiveMeta)}</EffMetaValue>
      </EffMetaCell>
    </EffMetaCard>
  );
}

// ──────────────────────────────────────────────────────────────────────────────
//  MAIN COMPONENT
// ──────────────────────────────────────────────────────────────────────────────
function MarginSimulator(props) {
  const { location: { idPage } } = props;
  const [auth, setAuth] = useState(null)

  // ─── search inputs ─────────────────────────────────────────────────────────
  const [searchMode, setSearchMode] = useState('order');   // 'order' | 'cpfcnpj'
  const [orderInput, setOrderInput] = useState('');
  const [docInput, setDocInput] = useState('');        // CPF/CNPJ with mask

  // ─── results state ─────────────────────────────────────────────────────────
  const [resultType, setResultType] = useState(null);      // null | 'order' | 'new_order' | 'cpfcnpj'
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadingMsg, setLoadingMsg] = useState('CONSULTANDO PEDIDO...');
  const [error, setError] = useState(null);
  const [timestamp, setTimestamp] = useState(null);

  // ─── historico ─────────────────────────────────────────────────────────────
  const [historico, setHistorico] = useState(null);
  const [loadingHist, setLoadingHist] = useState(false);
  const [loadingHistMsg, setLoadingHistMsg] = useState('');
  const [consumerName, setConsumerName] = useState('');

  // ─── meta efetiva / sugestões ──────────────────────────────────────────────
  const [effectiveMeta, setEffectiveMeta] = useState(META);
  const [avgMargemCliente, setAvgMargemCliente] = useState(0);
  const [newOrderSugs, setNewOrderSugs] = useState([]);
  const [displayDoc, setDisplayDoc] = useState('');  // doc formatado para exibição

  const styles = stylePageMargens();

  async function verifyAuth() {
    const { profile } = store.getState().user;
    const res = await apiLabs.post('valid_key', { id: profile.id, menu_id: idPage });
    if (res.data.message === "User not authorized") {
      return setAuth('denied')
    }
    if (res.data.message === "User authorized") {
      return setAuth('authorized')
    }
    return history.push({ pathname: '/', state: { from: props.location } });
  }

  // ─── clear ─────────────────────────────────────────────────────────────────
  const handleClear = useCallback(() => {
    setOrderInput('');
    setDocInput('');
    setResultType(null);
    setResult(null);
    setLoading(false);
    setError(null);
    setTimestamp(null);
    setHistorico(null);
    setLoadingHist(false);
    setLoadingHistMsg('');
    setConsumerName('');
    setEffectiveMeta(META);
    setAvgMargemCliente(0);
    setNewOrderSugs([]);
    setDisplayDoc('');
  }, []);

  // ─── historico helper (shared between order and cpfcnpj modes) ─────────────
  const processHistorico = useCallback((cpfCnpj, isNewOrderMode) => {
    setLoadingHist(true);
    fetchHistorico(cpfCnpj, msg => setLoadingHistMsg(msg))
      .then(hist => {
        setHistorico(hist);
        if (hist.consumerName) setConsumerName(hist.consumerName);
        if (hist.orders.length) {
          const avg = hist.orders.reduce((s, o) => s + o.margem, 0) / hist.orders.length;
          const effMeta = Math.max(META, avg);
          setAvgMargemCliente(avg);
          setEffectiveMeta(effMeta);
          if (isNewOrderMode) {
            setNewOrderSugs(computeNewOrderSuggestions(hist.histItems, effMeta));
          }
        }
      })
      .catch(e => { console.warn('Histórico:', e); setHistorico({ orders: [], histItems: [], consumerName: '' }); })
      .finally(() => setLoadingHist(false));
  }, []);

  // ─── search by order number ─────────────────────────────────────────────────
  const handleOrderSearch = useCallback(async () => {
    setError(null); setResult(null); setResultType(null);
    setHistorico(null); setConsumerName(''); setEffectiveMeta(META);
    setAvgMargemCliente(0); setNewOrderSugs([]); setDisplayDoc('');

    const raw = orderInput.trim();
    if (!raw) { setError('Informe o número do pedido.'); return; }
    const orderNum = stripLetters(raw);
    if (!orderNum) { setError('Nenhum número encontrado no campo.'); return; }

    setLoading(true);
    try {
      const data = await fetchOrder(orderNum, msg => setLoadingMsg(msg));
      setResult({ orderNum, ...data });
      setConsumerName(data.consumerName || '');
      const rt = data.isNewOrder ? 'new_order' : 'order';
      setResultType(rt);
      setTimestamp(new Date().toLocaleString('pt-BR'));
      if (data.consumerCpfCnpj) processHistorico(data.consumerCpfCnpj, data.isNewOrder);
    } catch (err) {
      setError('Erro: ' + err.message);
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, [orderInput, processHistorico]);

  // ─── search by CPF/CNPJ ─────────────────────────────────────────────────────
  const handleDocSearch = useCallback(async () => {
    setError(null); setResult(null); setResultType(null);
    setHistorico(null); setConsumerName(''); setEffectiveMeta(META);
    setAvgMargemCliente(0); setNewOrderSugs([]);

    const digits = docInput.replace(/\D/g, '');
    if (digits.length !== 11 && digits.length !== 14) {
      setError('CPF deve ter 11 dígitos e CNPJ 14 dígitos. Verifique o valor informado.');
      return;
    }

    setDisplayDoc(docInput);
    setResultType('cpfcnpj');
    setResult({ type: 'cpfcnpj', doc: digits });    // dummy para ativar render
    setLoadingHist(true);
    fetchHistorico(digits, msg => setLoadingHistMsg(msg))
      .then(hist => {
        setHistorico(hist);
        if (hist.consumerName) setConsumerName(hist.consumerName);
        setTimestamp(new Date().toLocaleString('pt-BR'));
        if (hist.orders.length) {
          const avg = hist.orders.reduce((s, o) => s + o.margem, 0) / hist.orders.length;
          const effMeta = Math.max(META, avg);
          setAvgMargemCliente(avg);
          setEffectiveMeta(effMeta);
          setNewOrderSugs(computeNewOrderSuggestions(hist.histItems, effMeta));
        }
      })
      .catch(e => { console.warn('Histórico:', e); setHistorico({ orders: [], histItems: [], consumerName: '' }); })
      .finally(() => setLoadingHist(false));
  }, [docInput]);

  // ─── unified search dispatcher ─────────────────────────────────────────────
  const handleSearch = useCallback(() => {
    if (searchMode === 'order') handleOrderSearch();
    else handleDocSearch();
  }, [searchMode, handleOrderSearch, handleDocSearch]);

  const handleKeyDown = useCallback(e => { if (e.key === 'Enter') handleSearch(); }, [handleSearch]);

  const margemVariant = result && resultType === 'order' ? valueVariant(result.margemPedido) : 'neutral';
  const histItems = historico?.histItems || [];
  const hasResult = !!result;

  useEffect(() => { verifyAuth(); }, []); // eslint-disable-line react-hooks/exhaustive-deps


  return (
    <Dashboard title="Consulta de Margens" styles={auth === 'authorized' && styles.main}>
      {auth === 'denied' && <Denied />}
      {
        auth === 'authorized' && <>
          <Container maxWidth="lg">
            <Grid container spacing={2}>

              <Grid item xs={12}>
                <h1 className={styles.titlePage}>Consulta de <span>Margens</span></h1>
                <p className={styles.subtitlePage}>IDWorks · Bluesoft · Cálculo automático de margem bruta</p>
              </Grid>

              <Grid item xs={12}>
                <PageGrid>
                  <PageInner>

                    {/* ── Mode bar ─────────────────────────────────────────── */}
                    <SearchModeBar>
                      <SearchModeTab $active={searchMode === 'order'} onClick={() => { setSearchMode('order'); handleClear(); }}>📦 Por Pedido</SearchModeTab>
                      <SearchModeTab $active={searchMode === 'cpfcnpj'} onClick={() => { setSearchMode('cpfcnpj'); handleClear(); }}>👤 Por CPF / CNPJ</SearchModeTab>
                      <ClearBtn onClick={handleClear} title="Limpar busca e resultados">✕ Limpar</ClearBtn>
                    </SearchModeBar>

                    {/* ── Search box ───────────────────────────────────────── */}
                    <SearchBox $mode={searchMode}>
                      <SearchField>
                        <SearchLabel htmlFor="mainInput">
                          {searchMode === 'order' ? 'Número do Pedido' : 'CPF / CNPJ do Cliente'}
                        </SearchLabel>
                        {searchMode === 'order' ? (
                          <SearchInput
                            id="mainInput" $mode="order" type="text"
                            placeholder="Ex: WTS123456 ou 123456"
                            autoComplete="off" spellCheck={false}
                            value={orderInput}
                            onChange={e => setOrderInput(e.target.value)}
                            onKeyDown={handleKeyDown}
                          />
                        ) : (
                          <SearchInput
                            id="mainInput" $mode="cpfcnpj" type="text"
                            placeholder="000.000.000-00 ou 00.000.000/0001-00"
                            autoComplete="off" spellCheck={false}
                            value={docInput}
                            onChange={e => setDocInput(applyDocMask(e.target.value))}
                            onKeyDown={handleKeyDown}
                          />
                        )}
                      </SearchField>
                      <SearchBtn $mode={searchMode} onClick={handleSearch} disabled={loading || loadingHist}>
                        {loading || loadingHist ? '...' : 'Buscar'}
                      </SearchBtn>
                    </SearchBox>

                    {loading && <LoadingRow><Spinner /><span>{loadingMsg}</span></LoadingRow>}
                    {error && <ErrorBox>{error}</ErrorBox>}

                    {/* ═══ RESULTADOS ═══ */}
                    {hasResult && (
                      <>
                        {/* ── Pedido com itens ────────────────────────────── */}
                        {resultType === 'order' && (
                          <>
                            <SummaryRow>
                              <SummaryCard $delay="0s"><CardLabel>Nº do Pedido</CardLabel><CardValue $variant="neutral">#{result.orderNum}</CardValue></SummaryCard>
                              <SummaryCard $delay="0.06s"><CardLabel>Itens</CardLabel><CardValue $variant="blue">{result.items.length}</CardValue></SummaryCard>
                              <SummaryCard $delay="0.12s"><CardLabel>Total Venda</CardLabel><CardValue $variant="neutral">{fmt(result.TV)}</CardValue></SummaryCard>
                              <SummaryCard $delay="0.18s"><CardLabel>Total Custo</CardLabel><CardValue>{fmt(result.TC)}</CardValue></SummaryCard>
                              <SummaryCard $delay="0.24s"><CardLabel>Margem Bruta</CardLabel><CardValue $variant={margemVariant}>{fmtPct(result.margemPedido)}</CardValue></SummaryCard>
                            </SummaryRow>
                            <SectionHeader><SectionTitle>Itens do Pedido</SectionTitle><Badge>{result.items.length} {result.items.length === 1 ? 'item' : 'itens'}</Badge></SectionHeader>
                            <ItemsList>{result.items.map((item, idx) => <OrderItem key={item.barcode || item.idSkuCompany || idx} item={item} index={idx} />)}</ItemsList>
                            <TotalRow>
                              <div><TotalRowLabel>Resumo Financeiro</TotalRowLabel><TotalFigures>Venda: <span>{fmt(result.TV)}</span>&nbsp;|&nbsp;Custo: <span>{fmt(result.TC)}</span></TotalFigures></div>
                              <div style={{ textAlign: 'right' }}><TotalRowLabel>Margem Bruta do Pedido</TotalRowLabel><TotalPct $variant={margemVariant}>{fmtPct(result.margemPedido)}</TotalPct></div>
                            </TotalRow>
                            <SugestaoSection items={result.items} TV={result.TV} TC={result.TC} margemAtual={result.margemPedido} histItems={histItems} />
                            <CompleteOrderSection isNewOrder={false} currentItems={result.items} TV={result.TV} TC={result.TC} margemAtual={result.margemPedido} histItems={histItems} loadingHist={loadingHist} effectiveMeta={META} />
                            <HistoricoSection historico={historico} loading={loadingHist} loadingMsg={loadingHistMsg} />
                          </>
                        )}

                        {/* ── Novo Pedido (sem itens) ──────────────────────── */}
                        {resultType === 'new_order' && (
                          <>
                            <NewOrderBanner>
                              <BannerIcon>🆕</BannerIcon>
                              <BannerInfo>
                                <BannerTitle $color="#60a5fa">Criando Novo Pedido</BannerTitle>
                                <BannerSub>Pedido <BannerStrong>#{result.orderNum}</BannerStrong> sem itens.{consumerName && <> Cliente: <BannerStrong>{consumerName}</BannerStrong>.</>} Carregando histórico para montar sugestões personalizadas.</BannerSub>
                              </BannerInfo>
                            </NewOrderBanner>
                            {!loadingHist && historico && <EffMetaSection avgMargemCliente={avgMargemCliente} effectiveMeta={effectiveMeta} />}
                            <CompleteOrderSection isNewOrder externalSuggestions={newOrderSugs} histItems={histItems} loadingHist={loadingHist} effectiveMeta={effectiveMeta} />
                            <HistoricoSection historico={historico} loading={loadingHist} loadingMsg={loadingHistMsg} />
                          </>
                        )}

                        {/* ── Busca por CPF/CNPJ ──────────────────────────── */}
                        {resultType === 'cpfcnpj' && (
                          <>
                            <ClienteBanner>
                              <BannerIcon>👤</BannerIcon>
                              <BannerInfo>
                                <BannerTitle $color="#3ecf8e">Histórico do Cliente</BannerTitle>
                                <BannerSub>
                                  Documento: <DocBadge>{displayDoc}</DocBadge>
                                  {consumerName && <> &nbsp;·&nbsp; Cliente: <BannerStrong>{consumerName}</BannerStrong></>}
                                </BannerSub>
                              </BannerInfo>
                            </ClienteBanner>

                            {/* Cards de resumo do cliente após carregar histórico */}
                            {historico && !loadingHist && (() => {
                              const orders = historico.orders || [];
                              const avgM = orders.length ? orders.reduce((s, o) => s + o.margem, 0) / orders.length : 0;
                              const totalG = orders.reduce((s, o) => s + o.total, 0);
                              return (
                                <SummaryRow>
                                  <SummaryCard $delay="0s"><CardLabel>Pedidos</CardLabel><CardValue $variant="blue">{orders.length}</CardValue></SummaryCard>
                                  <SummaryCard $delay="0.06s"><CardLabel>Produtos Únicos</CardLabel><CardValue $variant="neutral">{historico.histItems?.length || 0}</CardValue></SummaryCard>
                                  <SummaryCard $delay="0.12s"><CardLabel>Total Gasto</CardLabel><CardValue $variant="neutral">{fmt(totalG)}</CardValue></SummaryCard>
                                  <SummaryCard $delay="0.18s"><CardLabel>Margem Média</CardLabel><CardValue $variant={valueVariant(avgM)}>{fmtPct(avgM)}</CardValue></SummaryCard>
                                  <SummaryCard $delay="0.24s"><CardLabel>Meta Efetiva</CardLabel><CardValue $variant={effectiveMeta > META ? 'positive' : 'neutral'}>{fmtPct(effectiveMeta)}</CardValue></SummaryCard>
                                </SummaryRow>
                              );
                            })()}

                            {!loadingHist && historico && <EffMetaSection avgMargemCliente={avgMargemCliente} effectiveMeta={effectiveMeta} />}
                            <CompleteOrderSection isNewOrder externalSuggestions={newOrderSugs} histItems={histItems} loadingHist={loadingHist} effectiveMeta={effectiveMeta} />
                            <HistoricoSection historico={historico} loading={loadingHist} loadingMsg={loadingHistMsg} />
                          </>
                        )}
                      </>
                    )}

                    <PageFooter>
                      <span>Consulta de Margens v4.0</span>
                      {timestamp && <span>Última consulta: {timestamp}</span>}
                    </PageFooter>

                  </PageInner>
                </PageGrid>
              </Grid>
            </Grid>
          </Container>
        </>
      }
    </Dashboard>
  );
}

export default MarginSimulator;
